import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Agent.css";
axios.defaults.withCredentials = true;
const ITEMS_PER_PAGE = 30;

const Agent = () => {
  const [employees, setEmployees] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [newEmployee, setNewEmployee] = useState({
    name: "",
    email: "",
    department: "",
    phone: "",
    password: "",
  });
  const [updatedRoles, setUpdatedRoles] = useState({});
  const [departments, setDepartments] = useState([]);
  const [showAddForm, setShowAddForm] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [showDeactivateConfirm, setShowDeactivateConfirm] = useState(false);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [deactivateMessage, setDeactivateMessage] = useState("");
  const [deactivateMessageType, setDeactivateMessageType] = useState("");
  const [isDeactivatingEmployee, setIsDeactivatingEmployee] = useState(false);
  const [showResetConfirm, setShowResetConfirm] = useState(false);
  const [selectedResetEmployeeId, setSelectedResetEmployeeId] = useState(null);
  const [resetPasswordMessage, setResetPasswordMessage] = useState("");
  const [resetPasswordMessageType, setResetPasswordMessageType] = useState("");
  const [isResettingPassword, setIsResettingPassword] = useState(false);
  const [resetNewPassword, setResetNewPassword] = useState("");
  const [employeePopup, setEmployeePopup] = useState({
    show: false,
    type: "",
    title: "",
    message: "",
  });

  const showEmployeePopup = ({ type = "info", title = "", message = "" }) => {
    setEmployeePopup({
      show: true,
      type,
      title,
      message,
    });
  };

  const closeEmployeePopup = () => {
    setEmployeePopup({
      show: false,
      type: "",
      title: "",
      message: "",
    });
  };
  useEffect(() => {
    axios
     .get("/authadmin/me", { withCredentials: true })     
     .then((res) => setCurrentUser(res.data))
      .catch(() => setCurrentUser(null))
      .finally(() => {
        fetchEmployees();
        fetchDepartments();
      });
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [employees]);

  const fetchEmployees = async () => {
    try {
      const response = await axios.get("/employees", {
        withCredentials: true,
      });
      setEmployees(response.data);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  const fetchDepartments = async () => {
    try {
      const response = await axios.get("/department", {
        withCredentials: true,
      });
      setDepartments(response.data);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  const validateEmployeeForm = () => {
    const errors = {};
    const { name, email, department, phone, password } = newEmployee;

    if (!name.trim()) {
      errors.name = "กรุณากรอกชื่อพนักงาน";
    }

    if (!email.trim()) {
      errors.email = "กรุณากรอกอีเมล";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      errors.email = "รูปแบบอีเมลไม่ถูกต้อง";
    }

    if (!department) {
      errors.department = "กรุณาเลือกแผนก";
    }

    if (!phone.trim()) {
      errors.phone = "กรุณากรอกเบอร์โทรศัพท์";
    } else if (!/^[0-9]{10}$/.test(phone)) {
      errors.phone = "เบอร์โทรศัพท์ต้องเป็นตัวเลข 10 หลัก";
    }

    if (!password.trim()) {
      errors.password = "กรุณากรอกรหัสผ่าน";
    } else if (password.length < 6) {
      errors.password = "รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleAddEmployee = async () => {
    if (!validateEmployeeForm()) {
      return;
    }

    try {
      await axios.post("/employees", newEmployee, {
        withCredentials: true,
      });

      setNewEmployee({
        name: "",
        email: "",
        department: "",
        phone: "",
        password: "",
      });

      setFormErrors({});
      setShowAddForm(false);
      fetchEmployees();

      showEmployeePopup({
        type: "success",
        title: "เพิ่มพนักงานสำเร็จ",
        message: "Employee added successfully.",
      });
    } catch (error) {
      console.error("Error adding employee:", error);

      showEmployeePopup({
        type: "error",
        title: "เพิ่มพนักงานไม่สำเร็จ",
        message: error.response?.data?.error || "An unexpected error occurred.",
      });
    }
  };

  const handleDeleteEmployee = (id) => {
    setDeactivateMessage("");
    setDeactivateMessageType("");

    if (currentUser && Number(id) === Number(currentUser.id)) {
      setDeactivateMessage("You cannot deactivate your own account.");
      setDeactivateMessageType("error");
      return;
    }

    setSelectedEmployeeId(id);
    setShowDeactivateConfirm(true);
  };

  const confirmDeactivateEmployee = async () => {
    if (!selectedEmployeeId) return;

    setIsDeactivatingEmployee(true);
    setDeactivateMessage("");
    setDeactivateMessageType("");

    try {
      const response = await axios.put(
        `/employees/${selectedEmployeeId}`,
        {},
        {
          withCredentials: true,
        },
      );

      if (response.status === 200) {
        setShowDeactivateConfirm(false);
        setSelectedEmployeeId(null);

        setDeactivateMessage("Employee deactivated successfully!");
        setDeactivateMessageType("success");

        fetchEmployees();

        setTimeout(() => {
          setDeactivateMessage("");
          setDeactivateMessageType("");
        }, 3000);
      }
    } catch (error) {
      console.error("Error Deactivate employee:", error);

      setDeactivateMessage(
        error.response?.data?.error || "Failed to deactivate employee.",
      );
      setDeactivateMessageType("error");
    } finally {
      setIsDeactivatingEmployee(false);
    }
  };

  const handleChangeRole = (id, newRole) => {
    setUpdatedRoles((prev) => ({ ...prev, [id]: newRole }));
  };

  const handleConfirmRoleChange = async (id) => {
    if (currentUser && Number(id) === Number(currentUser.id)) {
      showEmployeePopup({
        type: "error",
        title: "ไม่สามารถเปลี่ยน Role ได้",
        message: "You cannot change your own role.",
      });
      return;
    }

    const employee = employees.find((emp) => Number(emp.id) === Number(id));

    if (employee && Number(employee.is_active) === 0) {
      showEmployeePopup({
        type: "error",
        title: "ไม่สามารถเปลี่ยน Role ได้",
        message: "Cannot change role for disabled employee.",
      });
      return;
    }

    const newRole = updatedRoles[id];

    if (!newRole) {
      showEmployeePopup({
        type: "error",
        title: "กรุณาเลือก Role",
        message: "Please select role before confirm.",
      });
      return;
    }

    try {
      const res = await fetch("/agent", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ employee_id: id, role: newRole }),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(data?.error || "Request failed");
      }

      showEmployeePopup({
        type: "success",
        title: "อัปเดต Role สำเร็จ",
        message: "Role updated successfully.",
      });

      fetchEmployees();
    } catch (err) {
      console.error("Error updating role", err);

      showEmployeePopup({
        type: "error",
        title: "อัปเดต Role ไม่สำเร็จ",
        message: err.message || "Failed to update role.",
      });
    }
  };

  const cancelDeactivateEmployee = () => {
    setShowDeactivateConfirm(false);
    setSelectedEmployeeId(null);
    setDeactivateMessage("");
    setDeactivateMessageType("");
  };

  const handleResetPassword = (id) => {
    setSelectedResetEmployeeId(id);
    setResetNewPassword("");
    setResetPasswordMessage("");
    setResetPasswordMessageType("");
    setShowResetConfirm(true);
  };

  const confirmResetPassword = async () => {
    if (!selectedResetEmployeeId) return;

    if (!resetNewPassword.trim()) {
      setResetPasswordMessage("กรุณากรอกรหัสผ่านใหม่");
      setResetPasswordMessageType("error");
      return;
    }

    if (resetNewPassword.length < 6) {
      setResetPasswordMessage("รหัสผ่านใหม่ต้องมีอย่างน้อย 6 ตัวอักษร");
      setResetPasswordMessageType("error");
      return;
    }

    setIsResettingPassword(true);
    setResetPasswordMessage("");
    setResetPasswordMessageType("");

    try {
      await axios.put(
        `/employees/${selectedResetEmployeeId}/reset-password`,
        {
          password: resetNewPassword,
        },
        {
          withCredentials: true,
        },
      );

      setShowResetConfirm(false);
      setSelectedResetEmployeeId(null);
      setResetNewPassword("");

      setResetPasswordMessage("Reset password successfully!");
      setResetPasswordMessageType("success");

      setTimeout(() => {
        setResetPasswordMessage("");
        setResetPasswordMessageType("");
      }, 3000);
    } catch (error) {
      console.error("Reset password error:", error);

      setResetPasswordMessage(
        error.response?.data?.error || "Failed to reset password.",
      );
      setResetPasswordMessageType("error");
    } finally {
      setIsResettingPassword(false);
    }
  };

  const cancelResetPassword = () => {
    setShowResetConfirm(false);
    setSelectedResetEmployeeId(null);
    setResetNewPassword("");
    setResetPasswordMessage("");
    setResetPasswordMessageType("");
  };

  const visibleEmployees = employees;

  const totalPages = Math.ceil(visibleEmployees.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const paginatedEmployees = visibleEmployees.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE,
  );

  return (
    <>
        <div className="agent-container">
          <h2 className="cus-info-title">Agent Management</h2>
          <div className="agent-add-header">
            <button
              type="button"
              className="open-add-employee-button"
              onClick={() => {
                setShowAddForm((prev) => !prev);
                setFormErrors({});
              }}
            >
              {showAddForm ? "Close Form" : "+ Add Employee"}
            </button>
          </div>

          {showAddForm && (
            <div className="employee-form-container">
              <div className="employee-field">
                <input
                  type="text"
                  placeholder="Name"
                  value={newEmployee.name}
                  onChange={(e) => {
                    setNewEmployee({ ...newEmployee, name: e.target.value });
                    setFormErrors((prev) => ({ ...prev, name: "" }));
                  }}
                  className={`employee-input ${formErrors.name ? "input-error" : ""}`}
                />
                {formErrors.name && (
                  <p className="employee-error-text">{formErrors.name}</p>
                )}
              </div>

              <div className="employee-field">
                <input
                  type="email"
                  placeholder="Email"
                  value={newEmployee.email}
                  onChange={(e) => {
                    setNewEmployee({ ...newEmployee, email: e.target.value });
                    setFormErrors((prev) => ({ ...prev, email: "" }));
                  }}
                  className={`employee-input ${formErrors.email ? "input-error" : ""}`}
                />
                {formErrors.email && (
                  <p className="employee-error-text">{formErrors.email}</p>
                )}
              </div>

              <div className="employee-field">
                <select
                  value={newEmployee.department}
                  onChange={(e) => {
                    setNewEmployee({
                      ...newEmployee,
                      department: e.target.value,
                    });
                    setFormErrors((prev) => ({ ...prev, department: "" }));
                  }}
                  className={`employee-input ${formErrors.department ? "input-error" : ""}`}
                >
                  <option value="">Select Department</option>
                  {departments.map((dept) => (
                    <option key={dept.id} value={dept.id}>
                      {dept.name}
                    </option>
                  ))}
                </select>
                {formErrors.department && (
                  <p className="employee-error-text">{formErrors.department}</p>
                )}
              </div>

              <div className="employee-field">
                <input
                  type="text"
                  placeholder="Phone"
                  value={newEmployee.phone}
                  maxLength={10}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^[0-9]*$/.test(value)) {
                      setNewEmployee({ ...newEmployee, phone: value });
                      setFormErrors((prev) => ({ ...prev, phone: "" }));
                    }
                  }}
                  className={`employee-input ${formErrors.phone ? "input-error" : ""}`}
                />
                {formErrors.phone && (
                  <p className="employee-error-text">{formErrors.phone}</p>
                )}
              </div>

              <div className="employee-field">
                <input
                  type="password"
                  placeholder="Password"
                  value={newEmployee.password}
                  onChange={(e) => {
                    setNewEmployee({
                      ...newEmployee,
                      password: e.target.value,
                    });
                    setFormErrors((prev) => ({ ...prev, password: "" }));
                  }}
                  className={`employee-input ${formErrors.password ? "input-error" : ""}`}
                />
                {formErrors.password && (
                  <p className="employee-error-text">{formErrors.password}</p>
                )}
              </div>

              <div className="employee-form-actions">
                <button
                  onClick={handleAddEmployee}
                  className="add-employee-button"
                >
                  Save Employee
                </button>

                <button
                  type="button"
                  className="cancel-add-employee-button"
                  onClick={() => {
                    setShowAddForm(false);
                    setFormErrors({});
                    setNewEmployee({
                      name: "",
                      email: "",
                      department: "",
                      phone: "",
                      password: "",
                    });
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          )}

          <div className="agent-employee-table-scroll">
            <table className="employee-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Department</th>
                  <th>Phone</th>
                  <th>Actions</th>
                  <th>Reset Password</th>
                  <th>Set Role</th>
                </tr>
              </thead>

              <tbody>
                {paginatedEmployees.length > 0 ? (
                  paginatedEmployees.map((employee) => (
                    <tr
                      key={employee.id}
                      className={
                        Number(employee.is_active) === 0
                          ? "employee-row-disabled"
                          : ""
                      }
                    >
                      <td>{employee.name}</td>
                      <td>{employee.email}</td>
                      <td>{employee.department_name}</td>
                      <td>{employee.phone}</td>

                      <td>
                        <button
                          _
                          onClick={() => handleDeleteEmployee(employee.id)}
                          className="delete-employee-button"
                          disabled={employee.is_active === 0}
                          style={{
                            backgroundColor:
                              employee.is_active === 0 ? "gray" : "",
                          }}
                        >
                          {employee.is_active === 1 ? "Deactivate" : "Disabled"}
                        </button>
                      </td>

                      <td>
                        <button
                          type="button"
                          onClick={() => handleResetPassword(employee.id)}
                          className="reset-password-button"
                          disabled={Number(employee.is_active) === 0}
                        >
                          Reset Password
                        </button>
                      </td>

                      <td>
                        {(() => {
                          const isSelf =
                            currentUser &&
                            Number(employee.id) === Number(currentUser.id);

                          const isInactive = Number(employee.is_active) === 0;
                          const isRoleDisabled = isInactive || isSelf;

                          return (
                            <>
                              <select
                                value={(
                                  updatedRoles[employee.id] ||
                                  employee.role ||
                                  "user"
                                ).toLowerCase()}
                                onChange={(e) =>
                                  handleChangeRole(employee.id, e.target.value)
                                }
                                className="role-select"
                                disabled={isRoleDisabled}
                              >
                                <option value="user">User</option>
                                <option value="admin">Admin</option>
                              </select>

                              <br />

                              <button
                                type="button"
                                onClick={() =>
                                  handleConfirmRoleChange(employee.id)
                                }
                                className="confirm-role-button"
                                disabled={isRoleDisabled}
                                title={
                                  isSelf
                                    ? "You cannot change your own role."
                                    : isInactive
                                      ? "Cannot change role for disabled employee."
                                      : ""
                                }
                              >
                                Confirm
                              </button>
                            </>
                          );
                        })()}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7">No data available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <div className="ticket-pagination">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Previous
              </button>

              {Array.from({ length: totalPages }, (_, index) => {
                const page = index + 1;

                return (
                  <button
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    className={currentPage === page ? "active-page" : ""}
                  >
                    {page}
                  </button>
                );
              })}

              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          )}
          {showDeactivateConfirm && (
            <div className="employee-modal-overlay">
              <div className="employee-confirm-modal">
                <h3>ยืนยันการปิดใช้งาน</h3>

                <p>ต้องการปิดใช้งานพนักงานคนนี้ใช่หรือไม่?</p>

                {deactivateMessage && (
                  <div
                    className={`employee-popup-message ${deactivateMessageType}`}
                  >
                    {deactivateMessage}
                  </div>
                )}

                <div className="employee-confirm-actions">
                  <button
                    type="button"
                    className="employee-confirm-danger-btn"
                    onClick={confirmDeactivateEmployee}
                    disabled={isDeactivatingEmployee}
                  >
                    {isDeactivatingEmployee ? "กำลังดำเนินการ..." : "ยืนยัน"}
                  </button>

                  <button
                    type="button"
                    className="employee-confirm-cancel-btn"
                    onClick={cancelDeactivateEmployee}
                    disabled={isDeactivatingEmployee}
                  >
                    ยกเลิก
                  </button>
                </div>
              </div>
            </div>
          )}

          {deactivateMessage && !showDeactivateConfirm && (
            <div className="employee-toast-wrapper">
              <div
                className={`employee-toast-message ${deactivateMessageType}`}
              >
                {deactivateMessage}
              </div>
            </div>
          )}
          {showResetConfirm && (
            <div className="reset-modal-overlay">
              <div className="reset-confirm-modal">
                <h3>ยืนยันการ Reset Password</h3>

                {/* <p>ต้องการ reset password ของพนักงานคนนี้ใช่หรือไม่?</p> */}
                <div className="reset-password-field">
                  <label>รหัสผ่านใหม่</label>
                  <input
                    type="password"
                    value={resetNewPassword}
                    onChange={(e) => {
                      setResetNewPassword(e.target.value);
                      setResetPasswordMessage("");
                      setResetPasswordMessageType("");
                    }}
                    placeholder="กรอกรหัสผ่านใหม่"
                    disabled={isResettingPassword}
                  />
                </div>

                {resetPasswordMessage && (
                  <div
                    className={`reset-popup-message ${resetPasswordMessageType}`}
                  >
                    {resetPasswordMessage}
                  </div>
                )}

                <div className="reset-confirm-actions">
                  <button
                    type="button"
                    className="reset-confirm-btn"
                    onClick={confirmResetPassword}
                    disabled={isResettingPassword}
                  >
                    {isResettingPassword ? "กำลังดำเนินการ..." : "ยืนยัน"}
                  </button>

                  <button
                    type="button"
                    className="reset-cancel-btn"
                    onClick={cancelResetPassword}
                    disabled={isResettingPassword}
                  >
                    ยกเลิก
                  </button>
                </div>
              </div>
            </div>
          )}

          {resetPasswordMessage && !showResetConfirm && (
            <div className="reset-toast-wrapper">
              <div
                className={`reset-toast-message ${resetPasswordMessageType}`}
              >
                {resetPasswordMessage}
              </div>
            </div>
          )}
          {employeePopup.show && (
            <div className="employee-alert-overlay">
              <div className="employee-alert-modal">
                <div
                  className={`employee-alert-icon ${
                    employeePopup.type === "success" ? "success" : "error"
                  }`}
                >
                  {employeePopup.type === "success" ? "✓" : "!"}
                </div>

                <h3>{employeePopup.title}</h3>

                <p>{employeePopup.message}</p>

                <div className="employee-alert-actions">
                  <button
                    type="button"
                    className={`employee-alert-btn ${
                      employeePopup.type === "success" ? "success" : "error"
                    }`}
                    onClick={closeEmployeePopup}
                  >
                    ตกลง
                  </button>
                </div>
              </div>
            </div>
          )}
      </div>
    </>
  );
};

export default Agent;
